// extracted by mini-css-extract-plugin
export default {"basic-button":"BasicButton_basic-button__7Jbc8","icon-wrapper":"BasicButton_icon-wrapper__XGuC7"};